var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCourseMetaPrice = function SvgIconCourseMetaPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1L1 3V36L19 47L37 36V3L19 1Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9917 12H18.6411C17.5981 12.0004 16.5858 12.3531 15.7681 13.0011C14.9504 13.649 14.3751 14.5542 14.1355 15.5702C13.8959 16.5861 14.006 17.6533 14.4479 18.5988C14.8898 19.5443 15.6376 20.3129 16.5704 20.78L21.4413 23.22C22.374 23.6871 23.1219 24.4557 23.5638 25.4012C24.0057 26.3467 24.1157 27.4139 23.8761 28.4298C23.6365 29.4458 23.0613 30.351 22.2436 30.9989C21.4258 31.6469 20.4135 31.9996 19.3705 32H14",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32V35",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V12",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCourseMetaPrice;